import { Box } from '@mui/material'
import React from 'react'
import { StyledLeadContainer } from '../../Components/Styled'
import { ACTIVE_STATUS, handleValidateCodevalue, TEMPLATE_STATUS, TEMPLATE_TYPE, templateChannel } from '../../Utility/constant'
import { useSelector } from 'react-redux'
import TextFiledWithLabel from '../../Components/TextFieldWithLabel'
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable'
import { WhoColumns } from '../../Components/WhoColumns'

const SearchTemplate = ({entityDetails,handleOnChange}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const lookupData = useSelector(state => state?.lookup?.lookupData);
        const getLookupCodes = (name) => lookupData?.find((item) => item?.name === name)?.codes?.filter(item => item?.status === ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);

        const templateStatus = getLookupCodes(TEMPLATE_STATUS);
        const templateType = getLookupCodes(TEMPLATE_TYPE);
  return (
    <Box sx={{
    '& .MuiTextField-root': { m: 1, width: '25ch', marginTop: 2 },
}}>
    <StyledLeadContainer>
        <TextFiledWithLabel
            name="name"
            value= {entityDetails?.name}
            label={handleValidateCodevalue(internationalise,'TEMP_SEARCH_NAME')}
            handleOnChange={handleOnChange}
        />
        <SelectBoxWithLabel
            isStatic={false}
            ownerdropdown={false}
            name="type"
            value= {entityDetails?.type ?? ""}
            label={ handleValidateCodevalue(internationalise,'TEMP_SEARCH_TYPE')}
            optionMenuItem={templateType}
            handleOnChange={handleOnChange}            
            />
            <SelectBoxWithLabel
                isStatic={true}
                name="channel"
                value= {entityDetails?.channel ?? ""}
                label={ handleValidateCodevalue(internationalise,'TEMP_SEARCH_CHANNEL')}
                optionMenuItem={templateChannel}
                handleOnChange={handleOnChange}                
            />        
            <SelectBoxWithLabel
                isStatic={false}
                ownerdropdown={false}
                name="status"
                value= {entityDetails?.status ?? ""}
                label= {handleValidateCodevalue(internationalise,'TEMP_SEARCH_STATUS')}
                optionMenuItem={templateStatus}
                handleOnChange={handleOnChange}
            />
        </StyledLeadContainer>
        <StyledLeadContainer>
            <TextFiledWithLabel
                name="subject"
                value= {entityDetails?.subject}
                sx = {{minWidth : "45.5%"}}
                required
                label= {handleValidateCodevalue(internationalise,'TEMP_SEARCH_SUBJECT')}
                handleOnChange={handleOnChange}
            />
            <SelectBoxWithLabel
                isStatic={true}
                ownerdropdown={false}
                name="systemTemplateFlag"
                value= {entityDetails?.systemTemplateFlag ?? ""}
                label= {handleValidateCodevalue(internationalise,'TEMP_SEARCH_EDITABLE')}
                optionMenuItem={[{label : "COMMON_YES",value : true},{label : "COMMON_NO", value : false}]}
                handleOnChange={handleOnChange}
            />
            <TextFiledWithLabel
            sx = {{visibility : "hidden"}}
            />
        </StyledLeadContainer>
        
        <WhoColumns
            searchState={entityDetails}
            handleOnChange={handleOnChange}
        />
    </Box>
  )
}

export default SearchTemplate